module.exports = __webpack_public_path__ + "v1.0.0/img/elite.9a89d9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/style/images/elite.png
// module id = QZUX
// module chunks = 9 18